import React, {ForwardRefRenderFunction, FunctionComponent, MutableRefObject, Ref, useContext} from 'react';
import {ThemeContext} from "../../../context/ThemeContext";
import {Theme} from "../../../models/theme.model";
import "./Textarea.scss";

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    ref: Ref<HTMLTextAreaElement>
}

export const Textarea = React.forwardRef<ForwardRefRenderFunction<HTMLTextAreaElement>, TextareaProps>((props, ref: any) => {
    const theme: Theme = useContext(ThemeContext).theme;

    return (
        <div>
            <textarea {...props} style={{'borderColor': theme.branding_color}} ref={ref} className={'textarea'}/>
        </div>
    )
});